export const ASSESSMENTRUN_INDEX = 'ASSESSMENT_RUN';
export const ASSESSMENTRUNQUESTION_INDEX = 'ASSESSMENTRUN_QUESTION';
export const CANDIDATE_INDEX = 'CANDIDATE';
export const GRADING_PARTY_INDEX = 'GRADING_PARTY';
export const USERQUESTION_INDEX = 'USERQUESTION';
export const GRADINGREADY_ISSUE = 'GRADINGREADY_ISSUE';
